// src/components/GlobalMenu.jsx
import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { SERVICES } from '../screens/CubaScreen';
import { estaVisiblePublicamente } from '../services/nuestrosClientesService';

function DrawerRow({ icon, color, label, sub, onClick, dashed }) {
  return (
    <button onClick={onClick} style={{
      width: '100%', display: 'flex', alignItems: 'center', gap: 12,
      padding: '11px 10px', borderRadius: 11, textAlign: 'left', background: 'transparent',
      border: dashed ? '1px dashed rgba(255,107,0,0.4)' : '1px solid transparent',
      marginBottom: dashed ? 4 : 0,
    }}>
      <span style={{
        width: 30, height: 30, borderRadius: 9, background: color,
        display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, flexShrink: 0,
      }}>{icon}</span>
      <span style={{ flex: 1 }}>
        <p style={{ fontSize: 13, fontWeight: 600, color: 'var(--white)' }}>{label}</p>
        {sub && <p style={{ fontSize: 10, color: 'var(--muted)', marginTop: 1 }}>{sub}</p>}
      </span>
      <span style={{ color: 'var(--muted)', fontSize: 13 }}>›</span>
    </button>
  );
}

function SectionLabel({ children }) {
  return <p style={{ margin: '16px 8px 6px', fontSize: 10, fontWeight: 800, letterSpacing: 1, color: 'var(--muted)', textTransform: 'uppercase' }}>{children}</p>;
}

export default function GlobalMenu({ onNavigate, onOpenAdmin }) {
  const { isAdmin } = useAuth();
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  const go = (target, service) => { onNavigate(target, service); close(); };

  // Mientras "Nuestros Clientes" esté en construcción (clientes_config.publicado
  // = false), este item queda oculto para cualquier cliente que no sea el
  // admin -- así nadie manda reseñas ni ve nada a medio terminar.
  const [clientesVisible, setClientesVisible] = useState(isAdmin);
  useEffect(() => { if (!isAdmin) estaVisiblePublicamente().then(setClientesVisible); }, [isAdmin]);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        aria-label="Abrir menú"
        style={{
          position: 'fixed', top: 'calc(env(safe-area-inset-top) + 14px)', left: 16,
          width: 38, height: 38, borderRadius: 11,
          background: 'rgba(22,32,64,0.88)', border: '1px solid var(--navy-border)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 200, backdropFilter: 'blur(6px)', boxShadow: '0 4px 14px rgba(0,0,0,0.3)',
        }}
      >
        <span style={{ position: 'relative', width: 16, height: 2, background: 'var(--orange)', borderRadius: 2 }}>
          <span style={{ position: 'absolute', left: 0, top: -5, width: 16, height: 2, background: 'var(--orange)', borderRadius: 2 }} />
          <span style={{ position: 'absolute', left: 0, top: 5, width: 16, height: 2, background: 'var(--orange)', borderRadius: 2 }} />
        </span>
      </button>

      {open && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 500 }}>
          <div onClick={close} style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.55)' }} />
          <div style={{
            position: 'absolute', top: 0, bottom: 0, left: 0, width: '84%', maxWidth: 300,
            background: 'var(--navy-light)', display: 'flex', flexDirection: 'column',
            boxShadow: '12px 0 40px rgba(0,0,0,0.5)',
          }}>
            <div style={{ padding: '22px 18px 16px', borderBottom: '1px solid var(--navy-border)', flexShrink: 0 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 14 }}>
                <img src="/logo-principal.png" alt="Click Travel Agency" style={{ width: 40, height: 40, objectFit: 'contain', borderRadius: 9, background: '#fff', padding: 4 }} />
                <button onClick={close} style={{
                  background: 'var(--navy-card)', border: '1px solid var(--navy-border)', color: 'var(--muted)',
                  width: 28, height: 28, borderRadius: 8, fontSize: 14,
                }}>✕</button>
              </div>
              <p style={{ fontSize: 14, fontWeight: 800, color: 'var(--white)' }}>Click Travel Agency</p>
              <p style={{ fontSize: 9.5, color: 'var(--orange)', fontWeight: 700, letterSpacing: 0.5, textTransform: 'uppercase' }}>International Travel Solutions</p>
            </div>

            <div style={{ flex: 1, overflowY: 'auto', padding: '8px 10px 20px' }}>
              <SectionLabel>Servicios</SectionLabel>
              {SERVICES.filter(s => s.active).map(svc => (
                <DrawerRow key={svc.id} icon={svc.icon} color={svc.color} label={svc.label} sub={svc.sub}
                  onClick={() => go('cuba', svc.id)} />
              ))}

              <SectionLabel>Asistencia</SectionLabel>
              <DrawerRow icon="🧠" color="rgba(107,130,168,0.20)" label="Asesores" onClick={() => go('asesores')} />

              <SectionLabel>La empresa</SectionLabel>
              {clientesVisible && (
                <DrawerRow icon="⭐" color="rgba(255,184,0,0.20)" label="Nuestros Clientes" sub="Fotos y reseñas reales" onClick={() => go('nuestros_clientes')} />
              )}
              <DrawerRow icon="ℹ️" color="rgba(255,107,0,0.20)" label="Quiénes somos" onClick={() => go('home')} />
              <DrawerRow icon="📲" color="rgba(193,53,132,0.18)" label="Redes sociales" onClick={() => go('more')} />
              <DrawerRow icon="💳" color="rgba(0,196,140,0.18)" label="Métodos de pago" onClick={() => go('more')} />

              <SectionLabel>Mi cuenta</SectionLabel>
              <DrawerRow icon="⭐" color="rgba(255,184,0,0.20)" label="Mis CLICKs" onClick={() => go('clicks')} />
              <DrawerRow icon="🔔" color="rgba(107,130,168,0.20)" label="Notificaciones" onClick={() => go('more')} />
              <DrawerRow icon="🎨" color="rgba(107,130,168,0.20)" label="Apariencia" onClick={() => go('more')} />
              {isAdmin && (
                <DrawerRow icon="⚙️" color="rgba(255,107,0,0.18)" label="Panel de Administrador" sub="Solo visible para ti"
                  dashed onClick={() => { onOpenAdmin(); close(); }} />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
